import { render } from "./AboutUsSchemajson.vue?vue&type=template&id=72f04a6e"
import script from "./AboutUsSchemajson.vue?vue&type=script&lang=js"
export * from "./AboutUsSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__